export default __webpack_public_path__ + "images/6H.db9c131.png";